import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC5YNx9FB0tVjDmA6m3WeQ9w4X0p0j2Ok4",
  authDomain: "teksa-5d07b.firebaseapp.com",
  projectId: "teksa-5d07b",
  storageBucket: "teksa-5d07b.appspot.com",
  messagingSenderId: "686182522347",
  appId: "1:686182522347:web:ae9176aa03a16f77d38dae",
  measurementId: "G-Q41PB6E7HC",
};
/*
const selectedLang = localStorage.getItem('i18nConfig')
const lang = selectedLang ? JSON.parse(selectedLang).selectedLang : 'fr'
*/
const app = initializeApp(firebaseConfig);
const authentication = getAuth(app);
// authentication.languageCode = lang
const db = getFirestore(app);
const storage = getStorage(app);
export { authentication, db, storage };
